import reactSizes from 'react-sizes'

const dummy = arg => undefined

// responsive props HOC
// https://github.com/renatorib/react-sizes#presets-selectors
export const withSizes = (fn = dummy) =>
  reactSizes(sizes => ({
    isDesktop: reactSizes.isDesktop(sizes),
    isMobile: reactSizes.isMobile(sizes),
    isTablet: reactSizes.isTablet(sizes),
    ...fn(sizes),
  }))

export const truncate = (str, maxWords) => {
  if (!str) {
    return str
  }
  const splitted = str.split(' ')
  if (splitted.length > maxWords) {
    return `${splitted.slice(0, maxWords).join(' ')}...`
  }
  return str
}



// WEBPACK FOOTER //
// ./src/app/utils.js